import { motion } from "framer-motion";

const EASE = [0.2, 0.8, 0.2, 1];

export const Reveal = ({ children, className = "", delay = 0, y = 28, as = "div", ...rest }) => {
  const Comp = motion[as] || motion.div;
  return (
    <Comp
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </Comp>
  );
};

const lineVariants = {
  hidden: { y: "110%" },
  show: (i) => ({ y: "0%", transition: { duration: 1.05, ease: [0.16, 1, 0.3, 1], delay: i * 0.09 } }),
};

export const MaskLines = ({ lines, className = "", lineClassName = "", onLoad = false, delay = 0, as = "h2", testId }) => {
  const Comp = motion[as] || motion.h2;
  const trigger = onLoad ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0.15 } };
  return (
    <Comp className={className} initial="hidden" {...trigger} data-testid={testId}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span className={`block ${lineClassName}`} variants={lineVariants} custom={i + delay * 10}>
            {line}
          </motion.span>
        </span>
      ))}
    </Comp>
  );
};

export const Eyebrow = ({ children, tone = "dark", className = "" }) => (
  <span className={`eyebrow ${tone === "dark" ? "text-leaf" : "text-leaf-deep"} ${className}`}>
    <span className={`h-1.5 w-1.5 rounded-full ${tone === "dark" ? "bg-leaf" : "bg-leaf-deep"}`} />
    {children}
  </span>
);

export const Stagger = ({ children, className = "", gap = 0.08 }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, amount: 0.15 }}
    variants={{ hidden: {}, show: { transition: { staggerChildren: gap } } }}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "", ...rest }) => (
  <motion.div
    className={className}
    variants={{ hidden: { opacity: 0, y: 24 }, show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: EASE } } }}
    {...rest}
  >
    {children}
  </motion.div>
);
